import React, { useState, useEffect } from "react";
import getLocalData from "../../../shared/localStorage/getData";
import getRemoveData from "../../../shared/localStorage/removeData";
import { NavLink, useNavigate } from "react-router-dom";
import Login from "../../../Pages/Login/new_login";
import { useRecoilValue } from "recoil";
import { cartState } from "../../../Pages/NambaStore/state/cartState";
import { FaShoppingCart } from "react-icons/fa"; // Import cart icon
import combinedServices from "../../../shared/services/user-service";
import CryptoJS from "crypto-js";
import { useRecoilState } from "recoil";
import userConstants from "../../../shared/constants/user-constants";
import { ticketCartCountState } from "../../../Pages/NambaStore/state/cartState";

const Header = () => {
  const cart = useRecoilValue(cartState);

  const [isLogin, setIsLogin] = useState(false);
  const [isClubDashboard, setIsClubDashboard] = useState(false);
  const [adminIsLogin, setAdminIsLogin] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [storeVisiblity, setStoreVisiblity] = useState(true);
  const [storeData, setStoreData] = useState([]);
  const [ticketCount, setTicketCount] = useRecoilState(ticketCartCountState);
  const secretKey = userConstants.CRYPTOSECRETKEY;
  const logo =
    "https://nambaweb.s3.ap-south-1.amazonaws.com/frontend-static-image/logo.png";
  const [wrapperClass,setWrapperClass] = useState(false)
    let navigate = useNavigate();

  useEffect(() => {
    if (getLocalData("user_info", "isLogin")) {
      var loginData = getLocalData("user_info", "all").userData
        .login_user_detail.data.user.clubOfficerIn;
       var districtId = getLocalData("user_info", "all").userData
        .login_user_detail.data.user.district;
      setIsLogin(getLocalData("user_info", "isLogin"));
      setIsClubDashboard(loginData.length > 0 ? true : false);
    }
    if (getLocalData("admin_info", "isLogin")) {
      setAdminIsLogin(true);
    }
    // fetchStoreStatus();
    fetchStorebyDistrictId(districtId);

    // Initialize Google Translate
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,es",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );
    };
    

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(script);

    // MutationObserver to detect language changes
    const observer = new MutationObserver(() => {
      const lang = document.documentElement.lang;
      console.log("Language changed to:", lang);
      setWrapperClass((prev)=>!prev)
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"],
    });
    return () => {
      observer.disconnect();
    };

  }, []);

  useEffect(() => {
    const updateTicketCount = () => {
      const encryptedData = localStorage.getItem("EventcartData");
      if (encryptedData) {
        try {
          const decrypted = CryptoJS.AES.decrypt(encryptedData, secretKey)
            .toString(CryptoJS.enc.Utf8);
          const tickets = JSON.parse(decrypted) || [];
          setTicketCount(tickets.length);
        } catch (error) {
          setTicketCount(0);
        }
      } else {
        setTicketCount(0);
      }
    };

    updateTicketCount();
    window.addEventListener("storage", updateTicketCount);
    return () => window.removeEventListener("storage", updateTicketCount);
  }, [setTicketCount]);

  const productCount = cart.reduce((total, item) => total + item.quantity, 0);
  const totalItems = productCount + ticketCount;

  // const fetchStoreStatus = async () => {
  //   try {
  //     const response = await combinedServices.storeStatus();
  //     setStoreVisiblity(response.data.data.data[0]);
  //     console.log("asdasdasd", response.data.data.data[0]);
  //   } catch (error) {
  //     console.error("Error fetching Store status:", error);
  //   }
  // };

  const fetchStorebyDistrictId = async (districtId) => {
    try {
      const response = await combinedServices.getstoresbydistrictId(districtId);
      if(response.data.data){
       const allUnavailable = response.data.data.every(store => store.isAvailable === false);
        if(response.data.data.length === 0 || allUnavailable){
          setStoreVisiblity(false);        }
        const availableStores = response.data.data.filter(store => store.isAvailable === true);
        setStoreData(availableStores);
      }
      console.log("asdasdasd", response.data.data);
    } catch (error) {
      console.error("Error fetching Store status:", error);
    }
  };

  const handleredirect = (storeID) => {
    navigate("/productListing",{ state: { storeID } });
  };


  const handleLogout = () => {
    getRemoveData("user_info");
    localStorage.clear();
    window.location.href = "/";
  };
  const handleRegister = () => {
    window.location.href = "https://member.namba.com/index.php?page=getstarted";
  };
  const [isActive, setActive] = useState(false);
  const [isStoreDropdownOpen, setIsStoreDropdownOpen] = useState(false);
  const [isStoreModalOpen, setIsStoreModalOpen] = useState(false);

  const toggleStoreModal = () => {
    setIsStoreModalOpen(!isStoreModalOpen);
  };

  const toggleClass = () => {
    setActive(!isActive);
  };

  const toggleStoreDropdown = () => {
    setIsStoreDropdownOpen(!isStoreDropdownOpen);
  };

  const handleStoreSelect = (storeID) => {
    setIsStoreModalOpen(false);
    handleredirect(storeID);
  };

  return (
    <>
      <header className={`header ${wrapperClass ? "wrapper-class":""}`} id="header">
        <div className="container">
          <div className="logo">
            <a href="/">
              <img src={logo} alt="NAMBA" />
            </a>
          </div>
          <a
            className={isActive ? "showMobMenu active" : "showMobMenu"}
            onClick={toggleClass}
          >
            <span>
              <i></i>
              <i></i>
              <i></i>
            </span>
          </a>

          <div
            className={
              isActive
                ? "headerInner flexBox itemCenter spacebetween active"
                : "headerInner flexBox itemCenter spacebetween"
            }
          >
            <nav className="menu">
              <ul className="flexBox">
                <li key="home" className="active">
                  <NavLink to="/">Home</NavLink>
                </li>
                {/* <li key="about-us"><NavLink to="/about-us">About</NavLink></li> */}
                {/*<li><NavLink to="/latest-news">Latest News</NavLink></li>*/}
                <li key="event">
                  <NavLink to="/upcoming-event">Events</NavLink>
                </li>
                <li key="club">
                  <NavLink to="/club">Club</NavLink>
                </li>
                <li key="club-result">
                  <NavLink to="/club-result">Results</NavLink>
                </li>
                {isLogin && (
                  <li key="my-races">
                    <NavLink to="/my-race">My Races</NavLink>
                  </li>
                )}
                {isLogin && storeVisiblity && (
                  <li key="productListing">
                    <a 
                      onClick={toggleStoreModal}
                      style={{ cursor: 'pointer' }}
                    >
                      STORES
                    </a>
                  </li>
                )}
                {/* {isLogin && storeVisiblity && ( 
                  <li key="productListing" className={`dropdown ${isStoreDropdownOpen ? 'show' : ''}`}>
                    <a 
                      className="dropdown-toggle" 
                      onClick={toggleStoreDropdown}
                      aria-haspopup="true" 
                      aria-expanded={isStoreDropdownOpen}
                      style={{ cursor: 'pointer' }}
                    >
                      STORES
                    </a>
                    <ul className={`dropdown-menu ${isStoreDropdownOpen ? 'show' : ''}`} style={{ display: isStoreDropdownOpen ? 'block' : 'none' }}>
                      {storeData.map((store) => (
                        <li key={store.id}>
                          <a style={{marginLeft:"10px"}}
                            onClick={(e) => {
                              e.preventDefault();
                              setIsStoreDropdownOpen(false);
                              handleredirect(store.id)
                            }}
                          >
                            {store.storename}
                          </a>
                        </li>
                      ))}
                    </ul> 
                  </li>
                )} */}
              
                {/* {isLogin &&<li key="addTocart"><NavLink to="/addTocart"> Cart ({cart.reduce((total, item) => total + item.quantity, 0)})</NavLink></li>} */}
              </ul>
            </nav>

            <div className="headerRgt flexBox itemCenter">
              {/* <ul className="socialLinks flexBox">
                <li key="linkein"><a href="#"><img src={linkein} alt="Linkedin" /></a></li>
                <li key="twitter"><a href="#"><img src={twitter} alt="Twitter" /></a></li>
                <li key="facebook"><a href="https://www.facebook.com/NAMBAInt"><img src={facebook} alt="Facebook" /></a></li>
                <li key="instagram"><a href="#"><img src={instagram} alt="Instagram" /></a></li>
    </ul> */}
              {isLogin ? (
                <div className="google-translate-login-wrapper d-flex flex-wrap align-items-center">

                <div className="topButtons flexBox me-2">
                  <div className="linkInner">
                    <NavLink to="/club-dashboard">Dashboard </NavLink>
                  </div>

                  <div className="linkInner">
                    <a href="#" onClick={handleLogout}>
                      Logout
                    </a>
                  </div>
                  <div className="linkInner">
                    <NavLink to="/addTocart" state={{ storeVisiblity }}>
                      <FaShoppingCart style={{ marginRight: "5px" }} />
                      Cart
                      ({totalItems})
                    </NavLink>
                  </div>
                </div>



                <div id="google_translate_element"></div>

                </div>
              ) : (
                
                <div className="google-translate-login-wrapper d-flex flex-wrap align-items-center">
                  <div className="topButtons flexBox me-2">
                    {adminIsLogin ? (
                      <div className="linkInner">
                        <NavLink to="/admin-dashboard">Dashboard</NavLink>
                      </div>
                    ) : (
                      <div className="linkInner">
                        <Login />
                      </div>
                    )}
                    <div className="linkInner">
                      <NavLink to="" onClick={handleRegister}>
                        Register
                      </NavLink>
                    </div>
                  </div>
                  <div id="google_translate_element"></div>
                </div>
              )}

            </div>
          </div>
        </div>
      </header>
      {isStoreModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '20px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80%',
            overflowY: 'auto'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0 }}>Available Stores</h2>
              <button 
                onClick={toggleStoreModal}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer'
                }}
              >
                ×
              </button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
              {storeData.map((store) => (
                <div 
                  key={store.id}
                  onClick={() => handleStoreSelect(store.id)}
                  style={{
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    padding: '15px',
                    cursor: 'pointer',
                    textAlign: 'center',
                    transition: 'transform 0.2s',
                    ':hover': { transform: 'scale(1.02)' }
                  }}
                >
                  {store.storeimage && (
                    <img 
                      src={store.storeimage} 
                      alt={store.storename}
                      style={{
                        width: '100%',
                        height: '150px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        marginBottom: '10px'
                      }}
                    />
                  )}
                  <h3 style={{ margin: '10px 0', fontSize: '16px' }}>{store.storename}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Header;
